<template>
  <div class="community-overview">
    <!-- 顶部标题栏 -->
    <div class="header">
      <div class="title">
        滕州市智慧社区综合管理服务平台
      </div>
      <div class="user-info">
        <span>你好，管理员</span>
        <el-avatar
          icon="User"
          class="avatar"
        />
      </div>
    </div>

    <!-- 主要内容区域 -->
    <div class="content-container">
      <!-- 左侧统计卡片区域 -->
      <div class="left-panel">
        <!-- 实有人口卡片 -->
        <el-card class="stat-card">
          <div class="card-header">
            实有人口
          </div>
          <div class="big-number">
            87589
          </div>
          <div class="stat-detail">
            <div>今日新增：3,869</div>
            <div>今日注销：7,010</div>
          </div>
          <div class="stat-chart">
            <div ref="populationChart" />
          </div>
        </el-card>

        <!-- 重点关注人员卡片 -->
        <el-card class="stat-card">
          <div class="card-header">
            重点关注人员
          </div>
          <div class="big-number">
            10559
          </div>
          <div class="stat-chart">
            <div ref="attentionPeopleChart" />
          </div>
        </el-card>

        <!-- 实有力量卡片 -->
        <el-card class="stat-card">
          <div class="card-header">
            实有力量
          </div>
          <div class="big-number">
            1569
          </div>
          <div class="stat-chart">
            <div ref="strengthChart" />
          </div>
        </el-card>

        <!-- 辖区服务卡片 -->
        <el-card class="stat-card">
          <div class="card-header">
            辖区服务
          </div>
          <div class="stat-subtitle">
            今日服务总数：7068
          </div>
          <div class="stat-chart">
            <div ref="serviceChart" />
          </div>
        </el-card>
      </div>

      <!-- 中央3D城市视图 -->
      <div class="central-view">
        <div class="city-model">
          <!-- 这里假设使用背景图片模拟3D城市效果 -->
          <div class="city-background" />
          <!-- 叠加统计数据 -->
          <div class="floating-stats">
            <div class="stat-item">
              <div class="stat-circle">
                8
              </div>
              <div class="stat-label">
                街道总数
              </div>
            </div>
            <div class="stat-item">
              <div class="stat-circle">
                129
              </div>
              <div class="stat-label">
                社区总数
              </div>
            </div>
            <div class="stat-item">
              <div class="stat-circle">
                400
              </div>
              <div class="stat-label">
                小区总数
              </div>
            </div>
          </div>
        </div>

        <!-- 动态感知卡片 -->
        <el-card class="dynamic-sensing-card">
          <div class="card-header">
            动态感知
          </div>
          <div class="big-number">
            8068
          </div>
          <div class="stat-subtitle">
            当日感知总量
          </div>
          <div class="sensing-chart">
            <div ref="sensingChart" />
          </div>
        </el-card>
      </div>

      <!-- 右侧统计卡片区域 -->
      <div class="right-panel">
        <!-- 辖区设备卡片 -->
        <el-card class="stat-card">
          <div class="card-header">
            辖区设备
          </div>
          <div class="big-number">
            7068
          </div>
          <div class="stat-chart">
            <div ref="devicesChart" />
          </div>
        </el-card>

        <!-- 辖区警情卡片 -->
        <el-card class="stat-card">
          <div class="card-header">
            辖区警情
          </div>
          <div class="big-number">
            568
          </div>
          <div class="stat-subtitle">
            当前预警情况单元
          </div>
          <div class="stat-chart">
            <div ref="alertsChart" />
          </div>
        </el-card>

        <!-- 辖区单位卡片 -->
        <el-card class="stat-card">
          <div class="card-header">
            辖区单位
          </div>
          <div class="stat-chart">
            <div ref="unitsChart" />
          </div>
        </el-card>

        <!-- 实有房屋卡片 -->
        <el-card class="stat-card">
          <div class="card-header">
            实有房屋
          </div>
          <div class="stat-chart">
            <div ref="housingChart" />
          </div>
        </el-card>

        <!-- 辖区档案卡片 -->
        <el-card class="stat-card">
          <div class="card-header">
            辖区档案
          </div>
          <div class="stat-chart">
            <div ref="archivesChart" />
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import * as echarts from 'echarts'

export default {
  name: 'CommunityOverview',
  setup() {

    // 图表引用
    const populationChart = ref(null)
    const attentionPeopleChart = ref(null)
    const strengthChart = ref(null)
    const serviceChart = ref(null)
    const sensingChart = ref(null)
    const devicesChart = ref(null)
    const alertsChart = ref(null)
    const unitsChart = ref(null)
    const housingChart = ref(null)
    const archivesChart = ref(null)
    const chartInstances = {}
    const resizeListeners = []

    // 初始化所有图表
    const initCharts = () => {
      // 实有人口图表
      initPopulationChart()
      // 重点关注人员图表
      initAttentionPeopleChart()
      // 实有力量图表
      initStrengthChart()
      // 辖区服务图表
      initServiceChart()
      // 动态感知图表
      initSensingChart()
      // 辖区设备图表
      initDevicesChart()
      // 辖区警情图表
      initAlertsChart()
      // 辖区单位图表
      initUnitsChart()
      // 实有房屋图表
      initHousingChart()
      // 辖区档案图表
      initArchivesChart()
    }

    // 实有人口图表
    const initPopulationChart = () => {
      forceInitChart(populationChart, {
        tooltip: { trigger: 'axis' },
        grid: { top: 5, right: 5, bottom: 5, left: 0, containLabel: true },
        xAxis: { type: 'category', data: ['常住人口', '登记人口', '流动人口', '户籍人口'], axisLabel: { interval: 0 } },
        yAxis: { type: 'value', show: false },
        series: [{
          type: 'bar',
          data: [2250, 6930, 1900, 800],
          itemStyle: { color: '#1890ff' },
          label: { show: true, position: 'top' }
        }]
      })
    }

    // 重点关注人员图表
    const initAttentionPeopleChart = () => {
      forceInitChart(attentionPeopleChart, {
        tooltip: { trigger: 'item' },
        series: [{
          type: 'pie',
          radius: ['40%', '70%'],
          avoidLabelOverlap: false,
          itemStyle: {
            borderRadius: 4,
            borderColor: '#001529',
            borderWidth: 2
          },
          label: { show: false, position: 'center' },
          emphasis: { label: { show: true, fontSize: 12 } },
          labelLine: { show: false },
          data: [
            { value: 2250, name: '自住房屋', itemStyle: { color: '#1890ff' } },
            { value: 1023, name: '租赁房屋', itemStyle: { color: '#36cbcb' } },
            { value: 1067, name: '闲置房屋', itemStyle: { color: '#ff6b6b' } },
            { value: 893, name: '空置房屋', itemStyle: { color: '#ffc107' } }
          ]
        }]
      })
    }

    // 实有力量图表
    const initStrengthChart = () => {
      forceInitChart(strengthChart, {
        tooltip: { trigger: 'item' },
        series: [{
          type: 'gauge',
          startAngle: 90,
          endAngle: -270,
          pointer: { show: false },
          progress: {
            show: true,
            overlap: false,
            roundCap: true,
            clip: false,
            itemStyle: { color: '#1890ff' }
          },
          axisLine: { lineStyle: { width: 15 } },
          splitLine: { show: false },
          axisTick: { show: false },
          axisLabel: { show: false },
          title: { show: false },
          detail: { show: false },
          data: [{ value: 58.2 }]
        },
        {
          type: 'pie',
          radius: ['60%', '75%'],
          avoidLabelOverlap: false,
          itemStyle: { borderRadius: 4, borderWidth: 2, borderColor: '#001529' },
          label: { show: true, fontSize: 10, formatter: '{b}: {d}%' },
          labelLine: { show: false },
          data: [
            { value: 582, name: '网格员', itemStyle: { color: '#1890ff' } },
            { value: 506, name: '党员', itemStyle: { color: '#ff6b6b' } },
            { value: 481, name: '志愿者', itemStyle: { color: '#36cbcb' } }
          ]
        }]
      })
    }

    // 辖区服务图表
    const initServiceChart = () => {
      forceInitChart(serviceChart, {
        tooltip: { trigger: 'axis' },
        grid: { top: 5, right: 5, bottom: 5, left: 0, containLabel: true },
        xAxis: { type: 'category', data: ['社区养老', '社区医疗', '社区文化', '社区教育', '社区环境', '残疾人服务'], axisLabel: { interval: 0, rotate: 30 } },
        yAxis: { type: 'value', show: false },
        series: [{
          type: 'bar',
          data: [3026, 2906, 2602, 2136, 2116, 1692],
          itemStyle: { color: '#36cbcb' },
          label: { show: true, position: 'top', fontSize: 10 }
        }]
      })
    }

    // 动态感知图表
    const initSensingChart = () => {
      forceInitChart(sensingChart, {
        tooltip: { trigger: 'axis' },
        grid: { top: 5, right: 5, bottom: 5, left: 0, containLabel: true },
        xAxis: { type: 'category', data: ['2', '4', '6', '8', '10', '12', '14', '16', '18', '20', '22', '24'], axisLabel: { interval: 0 } },
        yAxis: { type: 'value', min: 0, max: 100 },
        series: [
          {
            type: 'line',
            data: [20, 40, 35, 50, 49, 60, 70, 75, 65, 90, 80, 85],
            smooth: true,
            lineStyle: { width: 2, color: '#1890ff' },
            showSymbol: false,
            areaStyle: { color: { type: 'linear', x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: 'rgba(24, 144, 255, 0.3)' }, { offset: 1, color: 'rgba(24, 144, 255, 0)' }] } }
          },
          {
            type: 'line',
            data: [10, 30, 40, 30, 30, 50, 40, 50, 55, 70, 65, 75],
            smooth: true,
            lineStyle: { width: 2, color: '#ff6b6b' },
            showSymbol: false,
            areaStyle: { color: { type: 'linear', x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: 'rgba(255, 107, 107, 0.3)' }, { offset: 1, color: 'rgba(255, 107, 107, 0)' }] } }
          },
          {
            type: 'line',
            data: [5, 15, 25, 20, 40, 30, 35, 45, 40, 50, 55, 65],
            smooth: true,
            lineStyle: { width: 2, color: '#36cbcb' },
            showSymbol: false,
            areaStyle: { color: { type: 'linear', x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: 'rgba(54, 203, 203, 0.3)' }, { offset: 1, color: 'rgba(54, 203, 203, 0)' }] } }
          }
        ]
      })
    }

    // 辖区设备图表
    const initDevicesChart = () => {
      forceInitChart(devicesChart, {
        tooltip: { trigger: 'item' },
        series: [{
          type: 'pie',
          radius: '70%',
          data: [
            { value: 96, name: '门禁' },
            { value: 558, name: '视频监控' },
            { value: 557, name: '智慧灯杆' },
            { value: 227, name: '报警柱' },
            { value: 227, name: '网吧' },
            { value: 109, name: '智能手环' },
            { value: 102, name: '车辆道闸' },
            { value: 96, name: '门禁' }
          ],
          itemStyle: {
            color: function(params) {
              const colorList = ['#1890ff', '#36cbcb', '#ff6b6b', '#ffc107', '#722ed1', '#fa8c16', '#7cb305', '#eb2f96'];
              return colorList[params.dataIndex];
            }
          }
        }]
      })
    }

    // 辖区警情图表
    const initAlertsChart = () => {
      forceInitChart(alertsChart, {
        tooltip: { trigger: 'item' },
        series: [{
          type: 'funnel',
          left: 'center',
          top: 10,
          bottom: 60,
          width: '80%',
          minSize: '0%',
          maxSize: '100%',
          sort: 'descending',
          gap: 2,
          label: { show: true, position: 'inside', formatter: '{b}: {c}' },
          labelLine: { length: 10, lineStyle: { width: 1 } },
          itemStyle: {
            borderColor: '#001529',
            borderWidth: 1
          },
          emphasis: { label: { fontSize: 12 } },
          data: [
            { value: 1537, name: '布控预警(42%)', itemStyle: { color: '#1890ff' } },
            { value: 1378, name: '聚集预警(35%)', itemStyle: { color: '#36cbcb' } },
            { value: 1235, name: '环境异常预警(23%)', itemStyle: { color: '#ff6b6b' } }
          ]
        }]
      })
    }

    // 辖区单位图表
    const initUnitsChart = () => {
      forceInitChart(unitsChart, {
        tooltip: { trigger: 'axis' },
        grid: { top: 5, right: 5, bottom: 5, left: 0, containLabel: true },
        xAxis: { type: 'category', data: ['医院', '学校', '商场', '餐饮', '旅馆', '洗浴', '加油站', '加工厂'], axisLabel: { interval: 0, rotate: 30 } },
        yAxis: { type: 'value', show: false },
        series: [{
          type: 'bar',
          data: [112, 58, 55, 5168, 227, 110, 109, 227],
          itemStyle: { color: '#722ed1' },
          label: { show: true, position: 'top', fontSize: 10 }
        }]
      })
    }

    // 实有房屋图表
    const initHousingChart = () => {
      forceInitChart(housingChart, {
        tooltip: { trigger: 'item' },
        series: [{
          type: 'graph',
          layout: 'none',
          symbolSize: 50,
          roam: false,
          label: { show: true, formatter: '{b}' },
          edgeSymbol: ['none', 'arrow'],
          edgeSymbolSize: [0, 10],
          edgeLabel: { fontSize: 10 },
          data: [
            { name: '小区', value: 400, symbolSize: 60, itemStyle: { color: '#1890ff' } },
            { name: '楼栋', value: 9230, symbolSize: 50, itemStyle: { color: '#36cbcb' } },
            { name: '房屋', value: 347986, symbolSize: 40, itemStyle: { color: '#ff6b6b' } },
            { name: '自住', value: 2250, symbolSize: 30, itemStyle: { color: '#ffc107' } },
            { name: '合租', value: 1067, symbolSize: 30, itemStyle: { color: '#722ed1' } },
            { name: '空置', value: 893, symbolSize: 30, itemStyle: { color: '#fa8c16' } }
          ],
          links: [
            { source: '小区', target: '楼栋', lineStyle: { width: 2 } },
            { source: '楼栋', target: '房屋', lineStyle: { width: 2 } },
            { source: '房屋', target: '自住', lineStyle: { width: 1 } },
            { source: '房屋', target: '合租', lineStyle: { width: 1 } },
            { source: '房屋', target: '空置', lineStyle: { width: 1 } }
          ],
          lineStyle: {
            opacity: 0.9,
            width: 2,
            curveness: 0.2
          }
        }]
      })
    }

    // 辖区档案图表
    const initArchivesChart = () => {
      forceInitChart(archivesChart, {
        tooltip: { trigger: 'item' },
        series: [{
          type: 'pie',
          radius: ['40%', '70%'],
          data: [
            { value: 1000, name: '人口档案(11.1%)', itemStyle: { color: '#1890ff' } },
            { value: 1067, name: '房屋档案(11.8%)', itemStyle: { color: '#36cbcb' } },
            { value: 1234, name: '单位档案(13.7%)', itemStyle: { color: '#ff6b6b' } },
            { value: 3290, name: '重点档案(36.5%)', itemStyle: { color: '#ffc107' } },
            { value: 2421, name: '其他档案(26.9%)', itemStyle: { color: '#722ed1' } }
          ],
          label: { show: true, formatter: '{b}' }
        }]
      })
    }

    // 检查容器尺寸是否有效
    const hasValidSize = (container) => {
      if (!container) return false
      const rect = container.getBoundingClientRect()
      return rect.width > 0 && rect.height > 0
    }

    // 强制初始化图表
    const forceInitChart = (refName, option) => {
      requestAnimationFrame(() => {
        nextTick(() => {
          const container = refName.value
          if (!container) return

          // 检查并强制设置容器尺寸
          if (!hasValidSize(container)) {
            container.style.width = '100%'
            container.style.height = '100%'
            container.style.minHeight = '150px'
          }

          // 初始化图表
          try {
            const instance = echarts.init(container)
            instance.setOption(option)
            chartInstances[refName._rawValue] = instance

            // 添加resize监听
            const resizeHandler = () => instance.resize()
            window.addEventListener('resize', resizeHandler)
            resizeListeners.push(resizeHandler)
          } catch (error) {
            console.error('图表初始化失败:', error)
          }
        })
      })
    }

    onMounted(() => {
      initCharts()
    })

    onUnmounted(() => {
      // 清理图表实例和事件监听
      Object.values(chartInstances).forEach(instance => {
        if (instance && !instance.isDisposed()) {
          instance.dispose()
        }
      })
      resizeListeners.forEach(listener => {
        window.removeEventListener('resize', listener)
      })
    })

    return {
      populationChart,
      attentionPeopleChart,
      strengthChart,
      serviceChart,
      sensingChart,
      devicesChart,
      alertsChart,
      unitsChart,
      housingChart,
      archivesChart
    }
  }
}
</script>

<style scoped>
.community-overview {
  background: linear-gradient(135deg, #122a44, #0a1a2a);
  background-image: url('@/assets/beijing.png');
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  color: white;
  min-height: 100vh;
  padding: 15px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  margin-bottom: 20px;
}

.title {
  font-size: 20px;
  font-weight: bold;
  color: #fff;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.avatar {
  background-color: white;
}

.content-container {
  display: flex;
  gap: 20px;
  height: calc(100vh - 80px);
}

.left-panel, .right-panel {
  width: 25%;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.central-view {
  width: 50%;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

:deep(.stat-card) {
  background: linear-gradient(135deg, #122a44, #0a1a2a) !important;
  border-color: rgba(255, 255, 255, 0.1) !important;
  color: #fff !important;
  flex: 1;
  display: flex;
  flex-direction: column;
  box-shadow: 0 2px 15px rgba(24, 144, 255, 0.5), inset 0 0 25px rgba(24, 144, 255, 0.35) !important;
}

.card-header {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #fff;
}

.big-number {
  font-size: 24px;
  font-weight: bold;
  margin: 10px 0;
  color: white;
}

.stat-detail {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: white;
  margin-bottom: 10px;
}

.stat-subtitle {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 10px;
}

.stat-chart, .sensing-chart {
  width: 100%;
  flex: 1;
  min-height: 150px;
}

.city-model {
  flex: 1;
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
  position: relative;
  overflow: hidden;
}

.city-background {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  opacity: 0.7;
}

.floating-stats {
  position: absolute;
  top: 20px;
  left: 20px;
  right: 20px;
  display: flex;
  justify-content: space-around;
}

.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.stat-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: white;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  margin-bottom: 5px;
}

.stat-label {
  font-size: 12px;
  color: white;
}

.dynamic-sensing-card {
  background-color: rgba(255, 255, 255, 0.05);
  border-color: white;
  color: #fff;
  height: 250px;
}

:deep(.el-card__body) {
  padding: 15px !important;
  height: 100% !important;
  display: flex !important;
  flex-direction: column !important;
  box-sizing: border-box !important;
}

:deep(.el-avatar) {
  background-color: #1890ff;
}
</style>